import React, { useState } from 'react'
import './index.css'

function ModalStore({ closeModal, storeMessage }) {

    const inputHandler = () => {
        closeModal(false)
    }

    return (
        <div className='vidobo-modal-background'>
            <div className='vidobo-modal-container'>
                <div className='vidobo-modal-title'>
                    {storeMessage}
                </div>
                <div className='vidobo-modal-footer'>
                    {/* <button onClick={() => closeModal(false)}>
                        انصراف
                    </button> */}
                    <button onClick={() => inputHandler()}>
                        تایید
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalStore